<template>
  <div class="platform-selector">
    <h3
      v-if="!noTitle"
      class="h3"
    >
      Shortcut Groups
    </h3>
    <div class="node-form__tags tags">
      <md-autocomplete
        ref="serverInput"
        v-model="input"
        class="tags__input"
        :md-options="options.filter(o => !selected.some(s => s.group_id === o.group_id))"
        :md-fuzzy-search="false"
        @md-selected="addServerBundle"
      >
        <label>Choose shortcut groups</label>

        <template
          slot="md-autocomplete-item"
          slot-scope="{ item, term }"
        >
          <md-highlight-text :md-term="term">
            {{ item.title.en }}
          </md-highlight-text>
        </template>
      </md-autocomplete>

      <md-chip
        v-for="bundle in selected"
        :key="bundle.name"
        class="md-primary"
        md-deletable
        style="margin-right: 3px !important;"
        @click="deleteChip(bundle)"
      >
        {{ bundle.title.en }}
      </md-chip>
    </div>
  </div>
</template>
<script>
    export default {
        name: "ShortcutsGroupSelector",
        props: {
          initialShortcutGroups: { type: Array, default: () => [] },
          noTitle: { type: Boolean }
        },
        data() {
            return {
                options: [],
                input: "",
                selected: [],

                dictionary: [],
            };
        },
        watch: {
            "initialShortcutGroups": "updateBundlesFromProps",
        },
        mounted() {
            this.fetchServerBundles();
        },
        methods: {
            emitBundleUpdate() {
                this.$emit("groupListChanged", this.selected.map(g => g.group_id));
            },
            addServerBundle(bundle) {
                this.selected.push(bundle);

                this.emitBundleUpdate();
                this.input = "";
                this.$refs.serverInput.$data.searchTerm = "";
            },
            deleteChip(bundle) {
                this.selected = this.selected.filter(el => {
                    return el.group_id !== bundle.group_id;
                });

                this.emitBundleUpdate();
            },
            fetchServerBundles() {
                  this.$http.get("/v1/admin/system/shortcut-group/list").then(
                    res => {
                        this.options = res.data.shortcut_groups;
                        this.updateBundlesFromProps();
                    },
                    err => {
                        console.error(err);
                    },
                );
            },
            updateBundlesFromProps() {
                this.selected = this.$props.initialShortcutGroups?.length
                  ? this.$props.initialShortcutGroups.map(g => this.options.find(o => o.group_id === g))
                  : [];
            },
        }
    };
</script>
